import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  AnalyticsGranularity,
  AnalyticsGroupBy,
  AnalyticsPatients,
  AnalyticsPatientsGroupBy,
  AnalyticsResponse
} from "src/app/backend/models/analytics";
import { environment } from "src/environments/environment";

@Injectable()
export class AnalyticsPatientsBackend {
  private readonly http = inject(HttpClient);

  list({
    from,
    to,
    granularity,
    groupBy
  }: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsGroupBy;
  }): Observable<AnalyticsResponse<AnalyticsPatients>> {
    return this.http
      .get<AnalyticsResponse<AnalyticsPatients>>(
        `${environment.snoots.api.analytics}/patients`,
        {
          params: {
            from,
            to,
            granularity,
            groupBy
          }
        }
      )
      .pipe(
        map((response) => ({
          ...response,
          totalAverage: response.totalAverage || 0
        }))
      );
  }

  export(params: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsPatientsGroupBy;
  }): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.analytics}/patients/exports`,
      {
        from: params.from,
        to: params.to,
        granularity: params.granularity,
        groupBy: params.groupBy
      }
    );
  }
}
